$(function() {
	$(window).scroll(function() {

	});
	var egift = new EGIFT();
	//hachiKV.init();
	$(window).bind("resize",function(){egift.setPosition();});
	window.addEventListener("load", function() {
		egift.init();
		egift.setPosition();
	});
});
var EGIFT = function(){
	var self = this;

	self.init = function(){
		$(".faqContent").bind("click",function(){
			$(this).toggleClass("open");
		});
		$(".mv-egift").bind("click",function(){
			window.location.href="https://bake-the-online.com/collections/egift-summary";
		});
	}

	self.setPosition = function(){
		console.log("setPosition");
		$(".step").css("height","auto");
		$(".step img").css("display","inline");
		$(".step img").css("position","static");
		var steps = $("body").find(".step");
			console.log(steps);
		for(var i=0;i<steps.length;i++){
			var step = steps[i];
			var h = $(step).height()+20;
			var w = $(step).width();
			$(step).css("height",h+"px");
			$(step).find("img").css("display","block");
			$(step).find("img").css("position","absolute");
			$(step).find("img").css("bottom","0");
			var w2 = $(step).find("img").width();
			$(step).find("img").css("left",((w - w2)/2)+"px");
			//$(step).find("img").css("left","50%");
			//$(step).find("img").css("margin","auto");
		}
	}
}